"use client";

import { useUrlFilters } from "@/hooks/use-url-filters";
import { useSearchPageMapData } from "@/providers/search";
import { SearchList } from "../list";
import { SEOContentForSearch } from "../list/seo/content";
import { SearchMap } from "../map";
import { UnifiedMapControls } from "../map/unified-map-controls";

interface MobileLayoutProps {
	view: "map" | "list";
	onViewChange: (view: "map" | "list") => void;
}

export function MobileLayout({ view, onViewChange }: MobileLayoutProps) {
	const totalPropertiesCount = useSearchPageMapData(state => state.mapData?.length || 0);
	const shouldShowSeoBanner = view === "list";
	const { filters } = useUrlFilters();

	return (
		<>
			{/* Unified Map Controls - Bottom Right */}
			<UnifiedMapControls
				view={view}
				onViewChange={onViewChange}
				showViewToggles={true}
				filters={filters}
				className="fixed bottom-4 right-4"
				isMobile={true}
			/>

			<div className="w-full h-full">
				{view === "map" ? (
					<div className="w-full h-[calc(100vh-var(--header-height))] relative">
						<SearchMap mapControlsClassName="!hidden" />
						{/* No floating controls here anymore, handled by UnifiedMapControls above */}
					</div>
				) : (
					<div className="w-full flex flex-col">
						{/* List view takes 100vh */}
						<div className="w-full h-[calc(100vh-var(--header-height))]">
							<SearchList className="h-full" />
						</div>
						{/* SEO Banner: pulled to be sibling of list container */}
						{shouldShowSeoBanner && totalPropertiesCount > 0 && (
							<div className="w-full bg-gradient-to-r from-[#251821] to-[#31202C] min-h-[20vh] flex items-center justify-center">
								<SEOContentForSearch />
							</div>
						)}
					</div>
				)}
			</div>
		</>
	);
}
